/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureDiskRestoreData {
  /**
  * The ID of the disk to restore
  */
  'diskId': string;
  /**
  * Name of the disk to restore.
  */
  'diskName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskName",
      "baseName": "diskName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureDiskRestoreData.attributeTypeMap;
  }

  public constructor() {
  }
}

